import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./ImagePreview.module.css";

export default function ImagePreview({ src, alt, className }) {
  const [open, setOpen] = useState(false);

  const openPreview = () => {
    document.body.style.overflow = "hidden";
    setOpen(true);
  };

  const close = () => {
    document.body.style.overflow = "auto";
    setOpen(false);
  };


  const modal = open ? (
    <div className={styles.overlay} onClick={close}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={alt} className={styles.image} />
      </div>
    </div>
  ) : null;

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={className}
        onClick={openPreview}
        style={{ cursor: "pointer" }}
      />

      {createPortal(modal, document.body)}
    </>
  );
}